module.exports = __webpack_public_path__ + "static/media/logo.3878014a.png";